var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1429 6.55558C11.7944 6.55558 11.5082 6.29646 11.5082 5.9772C11.5082 5.65793 11.7868 5.39881 12.1353 5.39881H12.1429C12.4914 5.39881 12.7742 5.65793 12.7742 5.9772C12.7742 6.29646 12.4914 6.55558 12.1429 6.55558ZM8.00042 11.6793C6.19225 11.6793 4.72163 10.3313 4.72163 8.67478C4.72163 7.01906 6.19225 5.67181 8.00042 5.67181C9.8086 5.67181 11.2792 7.01906 11.2792 8.67478C11.2792 10.3313 9.8086 11.6793 8.00042 11.6793ZM12.7305 3.37524C12.5882 3.33436 12.3811 3.24876 12.2069 3.0737C12.1345 3.00121 12.0368 2.81999 11.9425 2.6457C11.6883 2.17451 11.3407 1.5298 10.6411 1.25989C9.74209 0.9144 6.29074 0.912858 5.36224 1.25835C4.67196 1.51823 4.32009 2.16603 4.06335 2.63876C3.96654 2.81613 3.86721 2.99967 3.79313 3.0737C3.61972 3.24953 3.41264 3.33436 3.28384 3.37215C0.508444 4.07547 0 5.72811 0 8.72799C0 13.0651 1.15494 15 8.00042 15C14.8451 15 16 13.0651 16 8.72799C16 5.72811 15.4924 4.07547 12.7305 3.37524Z",
    fill: "#FB7800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00053 6.82819C6.88852 6.82819 5.98443 7.65644 5.98443 8.67516C5.98443 9.69389 6.88852 10.5221 8.00053 10.5221C9.11254 10.5221 10.0166 9.69389 10.0166 8.67516C10.0166 7.65644 9.11254 6.82819 8.00053 6.82819Z",
    fill: "#FB7800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic-camera.e865340456e5c2529029431d7a67f44a.svg";
export { ForwardRef as ReactComponent };